var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval42AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 64",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M34 21c7.732 0 14 6.268 14 14s-6.268 14-14 14H14C6.268 49 0 42.732 0 35s6.268-14 14-14h20Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M46 35c0-6.627-5.373-12-12-12H14C7.373 23 2 28.373 2 35s5.373 12 12 12h20c6.627 0 12-5.373 12-12Zm2 0c0-7.732-6.268-14-14-14H14C6.268 21 0 27.268 0 35s6.268 14 14 14h20c7.732 0 14-6.268 14-14Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M19.224 60.83a2.5 2.5 0 0 1-2.488 2.254h-5.471a2.5 2.5 0 0 1-2.488-2.254l-.529-5.33c-.133-1.343 1.02-2.5 2.49-2.5h6.525c1.47 0 2.622 1.157 2.49 2.5l-.53 5.33Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M17.262 62.167c.686 0 1.314-.356 1.62-.919l.223-.408c.247-.453.848-.636 1.342-.41.494.227.694.777.447 1.23l-.222.408C20.026 63.252 18.706 64 17.262 64h-6.524c-1.444 0-2.764-.748-3.41-1.932l-.222-.408c-.247-.453-.047-1.003.447-1.23.494-.226 1.095-.043 1.342.41l.222.408c.307.563.935.919 1.621.919h6.524Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M39.224 60.83a2.5 2.5 0 0 1-2.488 2.254h-5.471a2.5 2.5 0 0 1-2.488-2.254l-.529-5.33c-.133-1.343 1.02-2.5 2.49-2.5h6.525c1.47 0 2.622 1.157 2.49 2.5l-.53 5.33Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M37.262 62.167c.686 0 1.314-.356 1.62-.919l.223-.408c.247-.453.848-.636 1.342-.41.494.227.694.777.447 1.23l-.222.408C40.026 63.252 38.706 64 37.262 64h-6.524c-1.444 0-2.764-.748-3.41-1.932l-.222-.408c-.247-.453-.047-1.003.447-1.23.494-.226 1.095-.043 1.342.41l.222.408c.307.563.935.919 1.621.919h6.524Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M23.5 13.5A2.5 2.5 0 0 1 21 16H9.5A2.5 2.5 0 0 1 7 13.5v-10A2.5 2.5 0 0 1 9.5 1H21a2.5 2.5 0 0 1 2.5 2.5v10ZM41 13.5a2.5 2.5 0 0 1-2.5 2.5H27a2.5 2.5 0 0 1-2.5-2.5v-10A2.5 2.5 0 0 1 27 1h11.5A2.5 2.5 0 0 1 41 3.5v10Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M41 12a1 1 0 0 1-1-1V3.5A1.5 1.5 0 0 0 38.5 2h-29A1.5 1.5 0 0 0 8 3.5V11a1 1 0 1 1-2 0V3.5A3.5 3.5 0 0 1 9.5 0h29A3.5 3.5 0 0 1 42 3.5V11a1 1 0 0 1-1 1Z",
  clipRule: "evenodd"
})));
SvgOval42AError.viewBox = '0 0 48 64';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval42AError);
export default ForwardRef;